import FlashlightSlash from './FlashlightSlash';

export default FlashlightSlash;
